import CA_PROVINCES from './PROFILE_CONSTANTS/CA_PROVINCES';
import US_STATES from './PROFILE_CONSTANTS/US_STATES';
import COUNTRIES from './PROFILE_CONSTANTS/COUNTRIES';
import GENDERS from './PROFILE_CONSTANTS/GENDERS';
import RETAILERS from './PROFILE_CONSTANTS/RETAILERS';
import DYNAMICS_ENTITIES from './PROFILE_CONSTANTS/DYNAMICS_ENTITIES';

import Configuration from './Configuration';

const configuration = Configuration.currentConfiguration();

const PROFILE_CONSTANTS = {
  LOGIN_REDIRECT: configuration.VUE_APP_LOGIN_REDIRECT, // process.env.VUE_APP_LOGIN_REDIRECT,
  ZESTY_ENDPOINT: configuration.VUE_APP_ZESTY_ENDPOINT, // process.env.VUE_APP_ZESTY_ENDPOINT,
  PROFILE_URL: configuration.VUE_APP_PROFILE_URL, // process.env.VUE_APP_PROFILE_URL,
  EDIT_URL: configuration.VUE_APP_EDIT_URL, // process.env.VUE_APP_EDIT_URL,
  API_ENDPOINT: configuration.VUE_APP_API_ENDPOINT, // process.env.VUE_APP_API_ENDPOINT,
  LOGIN_FLOW: configuration.LOGIN_FLOW,
  API_HEADERS: {
  	'Content-Type': 'application/json', // process.env.VUE_APP_API_HEADERS_ContentType,
	'Accept': 'application/json', // process.env.VUE_APP_API_HEADERS_Accept,
    'X-Env': configuration.VUE_APP_API_HEADERS_XEnv, // process.env.VUE_APP_API_HEADERS_XEnv,
    'X-Env-Braintree': configuration.VUE_APP_API_HEADERS_XEnvBraintree // process.env.VUE_APP_API_HEADERS_XEnvBraintree
  },
  CA_PROVINCES,
  US_STATES,
  COUNTRIES,
  GENDERS,
  RETAILERS,
  DYNAMICS_ENTITIES
};

function envInfo() {
  const info = { commit: process.env.GIT_COMMIT };
  const keys = ['ZESTY_ENDPOINT', 'LOGIN_REDIRECT', 'API_ENDPOINT', 'API_HEADERS', 'LOGIN_FLOW'];
  keys.forEach(key => info[key] = PROFILE_CONSTANTS[key]);
  return info;
}

export { PROFILE_CONSTANTS, envInfo };
